import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function ImpactoTimeline({ items, lang }) {
  const { t } = useTranslation();
  return (
    <ol
      className="relative border-l-2 border-salnes-atlantic/25 ml-3 space-y-10"
      data-testid="impacto-timeline"
    >
      {items.map((it, i) => (
        <motion.li
          key={it.phase}
          initial={{ opacity: 0, x: -10 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.05 }}
          className="pl-8"
          data-testid={`impacto-timeline-item-${it.phase}`}
        >
          <div className="absolute -left-[13px] w-6 h-6 rounded-full bg-salnes-atlantic flex items-center justify-center shadow-md">
            <Check size={12} className="text-white" />
          </div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
            {t("fase7.timeline_phase", { n: it.phase })} · {t("fase7.timeline_completed_at")}{" "}
            {it.completed_at}
          </div>
          <div className="font-serif text-xl lg:text-2xl text-salnes-ink mt-1">
            {lang === "es" ? it.name_es : it.name_gl}
          </div>
          <ul className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-salnes-stone">
            {(it.modules || []).map((m) => (
              <li key={m} className="before:content-['·'] before:mr-2 first:before:hidden">
                {m}
              </li>
            ))}
          </ul>
        </motion.li>
      ))}
    </ol>
  );
}
